import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=06807b34"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=06807b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports